/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};

//#region Init

rtAPI.messages = {
    store: [],
    targetSuffix: '',
    target: ''
};

//#endregion

//#region Show

rtAPI.messages.show = function (message) {
    if (!message || message == '') return
    this.renderMessages([{ 'text': message, 'type': 'none', 'icon': '' }]);
}

rtAPI.messages.showInformation = function (message) {
    if (!message || message == '') return
    this.renderMessages([{ 'text': message, 'type': 'information', 'icon': '/resource/icon-information.svg' }]);
}

rtAPI.messages.showWarning = function (message) {
    if (!message || message == '') return
    this.renderMessages([{ 'text': message, 'type': 'warning', 'icon': '/resource/icon-warning.svg' }]);
}

rtAPI.messages.showCritical = function (message) {
    if (!message || message == '') return
    this.renderMessages([{ 'text': message, 'type': 'critical', 'icon': '/resource/icon-critical.svg' }]);
}

//#endregion

//#region Add / Clear

rtAPI.messages.add = function (message) {
    if (!message || message == '') return
    this.renderMessages([{ 'text': message, 'type': 'none', 'icon': '' }]);
}

rtAPI.messages.addInformation = function (message) {
    if (!message || message == '') return
    this.store.push({ 'text': message, 'type': 'information', 'icon': '/resource/icon-information.svg' });
}

rtAPI.messages.addWarning = function (message) {
    if (!message || message == '') return
    this.store.push({ 'text': message, 'type': 'warning', 'icon': '/resource/icon-warning.svg' });
}

rtAPI.messages.addCritical = function (message) {
    if (!message || message == '') return
    this.store.push({ 'text': message, 'type': 'critical', 'icon': '/resource/icon-critical.svg' });
}

//#endregion

//#region Misc

rtAPI.messages.displayAddedMessages = function () {
    this.renderMessages(this.store);
    this.store = [];
}

rtAPI.messages.clear = function () {
    this.store = [];
    this.renderToDiv();
}

//#endregion

//#region Display / Render

rtAPI.messages.renderMessages = function (messages) {
    //this.clear();Messages should be manually cleared if needed
    if (!messages) return;
    if (messages.length == 0) return;

    var text = '';
    var type = '';
    messages.forEach(function (message) {
        switch (message.type) {
            case 'critical':
                type = 'critical';
                break;

            case 'warning':
                if (type != 'critical') type = message.type;
                break;

            case 'information':
                if (type == '') type = message.type;
                break;

            default:
                break;

        }
        //<li>
        text += `<li>${message.text}</li>`
    })
    this.renderToDiv(text, type);
}

rtAPI.messages.restore = function (innerHTML) {
    var messageDiv = rtAPI.messages.getMessageDiv();
    messageDiv.innerHTML = rtAPI.messages.savedMessages;
    messageDiv.className = rtAPI.messages.savedclasses;
    messageDiv.style = rtAPI.messages.savedstyles;
}

rtAPI.messages.save = function () {
    var messageDiv = rtAPI.messages.getMessageDiv();
    rtAPI.messages.savedMessages = messageDiv.innerHTML;
    rtAPI.messages.savedclasses = messageDiv.className;
    rtAPI.messages.savedstyles = messageDiv.style;
}

rtAPI.messages.getMessageDiv = function () {
    var messageDiv = document.getElementById(rtAPI.messages.messageDivTarget());
    if (!messageDiv) {
        messageDiv = document.createElement('div');
        messageDiv.id = rtAPI.messages.messageDivTarget();
        document.body.insertBefore(messageDiv, document.body.firstChild);


    }
    return messageDiv;
}

rtAPI.messages.messageDivTarget = function () {
    return (this.target != undefined && this.target != '') ? this.target : 'rtAPIMessageDiv' + this.targetSuffix;
}

rtAPI.messages.renderToDiv = function (message, type) {
    //debugger;

    var messageDiv = rtAPI.messages.getMessageDiv();

    var messageDivImageTarget = rtAPI.messages.messageDivTarget() + 'Image' + this.targetSuffix;
    var messageDivImage = document.getElementById(messageDivImageTarget);
    if (!messageDivImage) {
        messageDivImage = document.createElement('div');
        messageDivImage.id = messageDivImageTarget;
        messageDiv.appendChild(messageDivImage);
    }
    messageDivImage.className = 'error-componant__image image';

    var messageDivContentTarget = rtAPI.messages.messageDivTarget() + 'Content' + this.targetSuffix;
    var messageDivContent = document.getElementById(messageDivContentTarget);
    if (!messageDivContent) {
        messageDivContent = document.createElement("div");
        messageDivContent.id = messageDivContentTarget;
        messageDiv.appendChild(messageDivContent);
    }
    messageDivContent.className = 'error-componant__text';

    messageDiv.style.display = 'none';
    messageDiv.classList.remove("error-componant__information");
    messageDiv.classList.remove("error-componant__warning");
    messageDiv.classList.remove("error-componant__critical");
    messageDivContent.innerHTML = '';
    if (!message) return;

    messageDiv.style.display = 'block';
    var errorClass = "error-componant";
    if (type != '') errorClass = "error-componant error-componant__" + type;
    messageDiv.className = errorClass;

    var messageDivUl = document.createElement('ul');
    messageDivUl.innerHTML = message;
    messageDivContent.appendChild(messageDivUl);
}

//#endregion

